import { render, staticRenderFns } from "./SatinalmaTalephavuzu.vue?vue&type=template&id=295beb08&"
import script from "./SatinalmaTalephavuzu.vue?vue&type=script&lang=js&"
export * from "./SatinalmaTalephavuzu.vue?vue&type=script&lang=js&"
import style0 from "./SatinalmaTalephavuzu.vue?vue&type=style&index=0&id=295beb08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports